import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translation from './locales/en/translation.json';

// TODO: load resources from public locale files

/**
 * Initialize i18n for translation.
 * It uses backend to fetch translation file
 * from public folder based on language
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation,
      },
    },
  });

export default i18n;
